export const ROLES = {
  PLATFORM_ADMIN: 'PlatformAdmin',
  ADMIN: 'Admin',
  FINANCEIRO: 'Financeiro',
  OPERACIONAL: 'Operacional',
  AGRICULTOR: 'Agricultor',
};

export const ROLE_GROUPS = {
  plataforma: [ROLES.PLATFORM_ADMIN],
  administracao: [ROLES.ADMIN],
  financeiro: [ROLES.ADMIN, ROLES.FINANCEIRO],
  fiscal: [ROLES.ADMIN, ROLES.FINANCEIRO],
  operacional: [ROLES.ADMIN, ROLES.OPERACIONAL],
  operacionalAgricultor: [ROLES.ADMIN, ROLES.OPERACIONAL, ROLES.AGRICULTOR],
  financeiroOperacional: [ROLES.ADMIN, ROLES.FINANCEIRO, ROLES.OPERACIONAL],
  relatoriosOperacionais: [ROLES.ADMIN, ROLES.FINANCEIRO, ROLES.OPERACIONAL, ROLES.AGRICULTOR],
  todosTenant: [ROLES.ADMIN, ROLES.FINANCEIRO, ROLES.OPERACIONAL, ROLES.AGRICULTOR],
  todosAutenticados: [ROLES.PLATFORM_ADMIN, ROLES.ADMIN, ROLES.FINANCEIRO, ROLES.OPERACIONAL, ROLES.AGRICULTOR],
};

const PATH_RULES = [
  { prefix: '/novidades-admin', roles: ROLE_GROUPS.plataforma },
  { prefix: '/novidades', roles: ROLE_GROUPS.todosAutenticados },
  { prefix: '/assinaturas', roles: ROLE_GROUPS.plataforma },
  { prefix: '/usuarios', roles: ROLE_GROUPS.administracao },
  { prefix: '/auditoria', roles: ROLE_GROUPS.administracao },
  { prefix: '/onboarding-inicial', roles: ROLE_GROUPS.administracao },
  { prefix: '/ferramentas-gestao', roles: ROLE_GROUPS.financeiroOperacional },
  { prefix: '/importacao-dados', roles: ROLE_GROUPS.todosTenant },

  { prefix: '/cliente', roles: ROLE_GROUPS.financeiro },
  { prefix: '/fornecedor', roles: ROLE_GROUPS.financeiro },
  { prefix: '/categoriafinanceira', roles: ROLE_GROUPS.financeiro },
  { prefix: '/receita', roles: ROLE_GROUPS.financeiro },
  { prefix: '/despesa', roles: ROLE_GROUPS.financeiro },
  { prefix: '/contasPagarReceber', roles: ROLE_GROUPS.financeiro },
  { prefix: '/financeiro', roles: ROLE_GROUPS.financeiro },
  { prefix: '/notas-fiscais', roles: ROLE_GROUPS.fiscal },
  { prefix: '/configuracoes/certificado', roles: ROLE_GROUPS.fiscal },
  { prefix: '/cte', roles: ROLE_GROUPS.financeiroOperacional },
  { prefix: '/relatorios/financeiro', roles: ROLE_GROUPS.financeiro },

  { prefix: '/agricultores', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/propriedades', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/mapa-fazenda', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/talhoes', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/safras', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/plantios', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/insumos', roles: ROLE_GROUPS.operacional },
  { prefix: '/compras-insumos', roles: ROLE_GROUPS.operacional },
  { prefix: '/aplicacoesinsumo', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/maquinas', roles: ROLE_GROUPS.operacional },
  { prefix: '/operacoes-campo', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/colheitas', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/producao-agricola', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/romaneio-safra', roles: ROLE_GROUPS.operacional },
  { prefix: '/transportadoras', roles: ROLE_GROUPS.operacional },
  { prefix: '/pecuaria', roles: ROLE_GROUPS.operacionalAgricultor },
  { prefix: '/fechamento-safra', roles: ROLE_GROUPS.relatoriosOperacionais },
  { prefix: '/relatorioagricola', roles: ROLE_GROUPS.relatoriosOperacionais },
  {
    prefix: '/relatorios/operacoes-campo',
    roles: ROLE_GROUPS.relatoriosOperacionais,
  },
  { prefix: '/relatorios/colheita', roles: ROLE_GROUPS.relatoriosOperacionais },
  {
    prefix: '/relatorios/aplicacoes',
    roles: ROLE_GROUPS.relatoriosOperacionais,
  },
  { prefix: '/relatorios/integrado', roles: ROLE_GROUPS.financeiroOperacional },

  { prefix: '/menu', roles: ROLE_GROUPS.todosTenant },
  { prefix: '/fluxo-erp', roles: ROLE_GROUPS.todosTenant },
];

const MODULE_PATH_RULES = [
  {
    prefixes: ['/cliente'],
    modules: ['configuracoes', 'financeiro', 'fiscal', 'pecuaria'],
  },
  {
    prefixes: ['/fornecedor'],
    modules: ['configuracoes', 'financeiro', 'fiscal', 'estoque', 'pecuaria'],
  },
  {
    prefixes: ['/agricultores', '/propriedades', '/mapa-fazenda'],
    modules: ['configuracoes', 'producao', 'pecuaria', 'fiscal'],
  },
  {
    prefixes: ['/talhoes', '/safras', '/colheitas'],
    modules: ['producao', 'estoque', 'financeiro', 'logistica', 'relatorios'],
  },
  { prefixes: ['/insumos'], modules: ['estoque', 'pecuaria', 'logistica'] },
  { prefixes: ['/transportadoras'], modules: ['logistica', 'fiscal'] },
  { prefixes: ['/maquinas'], modules: ['logistica', 'producao'] },
  { prefixes: ['/pecuaria'], modules: ['pecuaria'] },
  {
    prefixes: ['/notas-fiscais', '/configuracoes/certificado', '/cte'],
    modules: ['fiscal'],
  },
  {
    prefixes: ['/receita', '/despesa', '/contasPagarReceber', '/financeiro', '/categoriafinanceira'],
    modules: ['financeiro'],
  },
  { prefixes: ['/romaneio-safra'], modules: ['logistica'] },
  {
    prefixes: ['/compras-insumos', '/aplicacoesinsumo', '/producao-agricola'],
    modules: ['estoque'],
  },
  { prefixes: ['/plantios', '/operacoes-campo'], modules: ['producao'] },
  {
    prefixes: ['/fechamento-safra', '/relatorioagricola', '/relatorios'],
    modules: ['relatorios'],
  },
  {
    prefixes: ['/usuarios', '/auditoria', '/onboarding-inicial'],
    modules: ['configuracoes'],
  },
  { prefixes: ['/menu', '/fluxo-erp'], modules: ['gestao', 'lia'] },
  { prefixes: ['/ferramentas-gestao'], modules: ['gestao'] },
  {
    prefixes: ['/importacao-dados'],
    modules: ['gestao', 'producao', 'estoque', 'pecuaria', 'financeiro', 'logistica'],
  },
];

export function getModulesForPath(pathname) {
  return MODULE_PATH_RULES.find((rule) => rule.prefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`)))?.modules || [];
}

export function canAccessModulePath(pathname, modules) {
  const acceptedModules = getModulesForPath(pathname);
  return acceptedModules.length === 0 || acceptedModules.some((module) => modules.includes(module));
}

export function getDefaultPathForModules(modules) {
  const landings = {
    gestao: '/menu',
    producao: '/propriedades',
    estoque: '/insumos',
    pecuaria: '/pecuaria',
    financeiro: '/financeiro/controle-agro',
    logistica: '/transportadoras',
    fiscal: '/notas-fiscais',
    relatorios: '/relatorios/integrado',
    configuracoes: '/usuarios',
    lia: '/menu',
  };
  return modules.map((module) => landings[module]).find(Boolean) || '/login';
}

export function getUserRoles(token) {
  if (!token) return [];

  try {
    const payload = token.split('.')[1];
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    const roleClaim = json.role || json['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];

    if (Array.isArray(roleClaim)) {
      return roleClaim;
    }

    return roleClaim ? [roleClaim] : [];
  } catch {
    return [];
  }
}

export function getUserTenant(token) {
  if (!token) return '';

  try {
    const payload = token.split('.')[1];
    const json = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    return json.tenant || json.tenantId || '';
  } catch {
    return '';
  }
}

export function hasAnyRole(userRoles, allowedRoles) {
  if (!allowedRoles || allowedRoles.length === 0) return true;
  return userRoles.some((role) => allowedRoles.includes(role));
}

export function canAccessPath(pathname, userRoles) {
  const rule = PATH_RULES.filter((item) => pathname === item.prefix || pathname.startsWith(`${item.prefix}/`)).sort((a, b) => b.prefix.length - a.prefix.length)[0];

  return rule ? hasAnyRole(userRoles, rule.roles) : true;
}
